import { WarningOutlined } from '@ant-design/icons';
import { Alert, Modal, Typography } from 'antd';
import Buttons from 'components/Global/Buttons';
import styles from './index.module.scss';

const { Title } = Typography;

interface NapsaConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	percentage: number;
	isLoading: boolean;
}

const NapsaConfirmModal: React.FC<NapsaConfirmModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	percentage,
	isLoading,
}) => {
	const myButtons = [
		{
			text: 'Cancel',
			isLoading: false,
			className: 'secondary-button',
			fontSize: '1.8rem',
			disabled: isLoading,
			minWidth: '12rem',
			minHeight: '4rem',
			isSubmit: false,
			onclick: () => {
				onClose();
			},
		},
		{
			text: 'Confirm',
			isLoading: isLoading,
			className: 'btn-blue',
			fontSize: '1.8rem',
			disabled: isLoading,
			minWidth: '12rem',
			minHeight: '4rem',
			isSubmit: true,
			onclick: () => {
				onConfirm();
			},
		},
	];
	return (
		<Modal
			title="NAPSA Percentage Confirmation"
			open={isOpen}
			onCancel={onClose}
			footer={null}
			width={700}
			maskClosable={false}
			centered
			closable={false}
		>
			<div className={styles.modalContent}>
				<Alert
					message="Official Notice"
					description={`You are about to implement a NAPSA contribution rate of ${percentage}%. Please verify this information before proceeding.`}
					type="warning"
					showIcon
					icon={<WarningOutlined />}
					className={styles.alert}
				/>

				<div className={styles.systemActions}>
					<Title level={5}>
						Upon confirmation, please be advised:
					</Title>
					<ul>
						<li>
							The specified percentage rate will be applied to all
							NAPSA deductions following the effective start date
						</li>
						<li>
							It is essential to verify this percentage with the
							Zambia Revenue Authority (ZRA) before implementation
						</li>
						<li>
							Non-compliance with official NAPSA requirements may
							result in rejection of contributions and potential
							regulatory issues
						</li>
					</ul>
				</div>

				<div className={styles.actionButtons}>
					<Buttons buttons={myButtons} />
				</div>
			</div>
		</Modal>
	);
};

export default NapsaConfirmModal;
